import { ErrorOutline30Icon } from "@vygruppen/spor-icon-react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DropsButton, Stack, Text, TextLink } from "shared/components/Spor";

type FailureMessageWithRetryButtonProps = {
  retryFunction: () => void;
  customMessage?: string;
  retryLabel?: string;
};

export const FailureMessageWithRetryButton: FC<
  FailureMessageWithRetryButtonProps
> = ({ customMessage, retryFunction, retryLabel }) => {
  const { t } = useTranslation();
  return (
    <Stack alignItems="center" alignContent="center" gap="12px">
      <ErrorOutline30Icon />

      <Text fontSize="18px" maxWidth="700px" textAlign="center">
        {customMessage ??
          t(
            "Noe gikk galt ved lasting av innhold. Last siden på nytt for å prøve igjen. Dersom feilen vedvarer, ",
          )}
        <TextLink
          href="mailto:team-brukerflater-drops@vy.no?cc=vygruppen@service-now.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ display: "inline" }}
        >
          {t("ta kontakt med IT.")}
        </TextLink>
      </Text>

      <DropsButton onClick={retryFunction} size="xs" variant="primary" mt="6px">
        {retryLabel ?? t("Last på nytt")}
      </DropsButton>
    </Stack>
  );
};
